import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'
import { InsuranceCoverage } from 'containers/OpportunityCarInsurance/types'

import { ButtonLink, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { Header } from 'components/Layout'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.CurrentCoverage> & {
	onShowConsent: Handlers['onShowConsent']
	onStepBack?: () => void
}

const topics = [
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.currentCoverage.labelLegalLiabilityInsurance'
				defaultMessage='Legal Liability Insurance'
			/>
		),
		value: InsuranceCoverage.Simple,
	},
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.currentCoverage.labelLegalLiabilityInsuranceAndLimitedCasco'
				defaultMessage='Legal Liability Insurance + limited casco'
			/>
		),
		value: InsuranceCoverage.LimitedCasco,
	},
	{
		label: (
			<FormattedMessage
				id='opportunityCarInsurance.currentCoverage.labelLegalLiabilityInsuranceAndFullCasco'
				defaultMessage='Legal Liability Insurance + full casco'
			/>
		),
		value: InsuranceCoverage.FullCasco,
	},
]

export const CurrentCoverage = ({
	selectedInsurer,
	personalDetails,
	licensePlate,
	damageFreeYears,
	drivenDistancePerYear,
	onShowConsent,
	onStepBack,
}: Props) => (
	<Card>
		<Header>
			<Title>
				<FormattedMessage
					id='opportunityCarInsurance.currentCoverage.title'
					defaultMessage='What is your current coverage?'
				/>
			</Title>
		</Header>
		<p role='text' style={{ marginBottom: '16px' }}>
			<FormattedMessage
				id='opportunityCarInsurance.currentCoverage.description'
				defaultMessage='You can find this on the most recently issued policy sheet of your current insurance policy.'
			/>
		</p>
		<div style={{ marginTop: '8px' }}>
			{topics.map(({ label, value }) => (
				<ButtonLink
					label={label}
					onClick={() =>
						onShowConsent(selectedInsurer, personalDetails, licensePlate, damageFreeYears, drivenDistancePerYear, value)
					}
				/>
			))}
		</div>
		<ButtonGroup center>
			{onStepBack && (
				<ButtonText
					label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
					onClick={() => onStepBack()}
				/>
			)}
		</ButtonGroup>
	</Card>
)
